import { render, staticRenderFns } from "./TariffBenefitForm.vue?vue&type=template&id=261ae1da&"
import script from "./TariffBenefitForm.vue?vue&type=script&lang=js&"
export * from "./TariffBenefitForm.vue?vue&type=script&lang=js&"
import style0 from "./TariffBenefitForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TariffBenefitForm.vue"
export default component.exports